/** Map host height: parent chain often lacks computed % height (see gis-bids / requests map panel). */
export const GIS_BIDS_MAP_HEIGHT_CSS = 'calc(100vh - 270px)';
